module.exports = __webpack_public_path__ + "assets/img/help_next.2c2a0aa8.svg";